import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable' // Angular 5/RxJS 5.5 syntax
import { HttpClient } from '@angular/common/http'
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { environment } from '../../../environments/environment'
import { PageEvent } from '@angular/material'
import { AdministrationResponse } from '../models/administration-response'
import { sprintf } from 'sprintf'
import { ActivatedRoute, ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router'
import 'rxjs/add/observable/of'
import 'rxjs/add/operator/delay'
import 'rxjs/Rx'
import { AdministrationModel } from '../models/administration.model'
import { ResourceLoadingService } from './resource-loading.service'

@Injectable()
export class AdministrationService implements Resolve<Observable<any>> {
  private readonly _url = environment.base_url + '/v2/support/administrations'
  private readonly support_url = environment.base_url + '/v2/support/administrations'

  administrationId: number
  currentAdministration: AdministrationModel
  administrations: AdministrationModel[]
  administrationsResponse: AdministrationResponse

  filters: any
  onCurrentAdministationChanged: BehaviorSubject<any> = new BehaviorSubject(undefined)
  onAdministrationsChanged: BehaviorSubject<AdministrationResponse> = new BehaviorSubject<AdministrationResponse>(
    undefined,
  )

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private _loadingService: ResourceLoadingService,
  ) {
    this.administrationId = this.route.snapshot.params['administrationId']

    this.administrations = []

    this.filters = {
      paginated: true,
      limit: 10,
    }
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    this.administrationId = route.params['administrationId']

    if (route.params['searchQuery']) {
      this.filters.search = route.params['searchQuery']
    }

    if (this.administrationId) {
      return this.get(this.administrationId)
    } else {
      return this.browse()
    }
  }

  public getSearch(): string {
    return this.filters.search
  }

  changeSearch(search: string) {
    this.filters.search = search
  }

  changeFilter(event?: PageEvent) {
    this.filters.page = event.pageIndex + 1
    this.filters.limit = event.pageSize
    this.browse().subscribe()
  }

  isStopped(value: boolean) {
    this.filters.is_stopped = value
    this.browse().subscribe()
  }

  clearFilter() {
    delete this.filters.is_stopped
    delete this.filters.search
    this.browse().subscribe()
  }

  /**
   * Get a list of administrations
   * @returns {Observable<AdministrationResponse>}
   */
  public browse() {
    this._loadingService.loading(true)
    return this.http
      .get<AdministrationResponse>(this._url, { params: this.filters })
      .map(administrationResponse => {
        this.administrationsResponse = new AdministrationResponse(administrationResponse)
        this.onAdministrationsChanged.next(this.administrationsResponse)
        this._loadingService.loading(false)
        return this.administrationsResponse
      })
  }

  /**
   *
   * @param {number} adminId
   * @returns {Observable<AdministrationModel>}
   */
  public get(adminId: number): Observable<AdministrationModel> {
    return this.http.get<AdministrationModel>(`${this._url}/${adminId}`).map(response => {
      this.currentAdministration = new AdministrationModel(response)
      this.onCurrentAdministationChanged.next(this.currentAdministration)
      return this.currentAdministration
    })
  }

  /**
   *
   * @param {AdministrationModel} administration
   * @returns {Observable<Array<AdministrationModel>>}
   */
  public manDown(administration: AdministrationModel): Observable<AdministrationModel> {
    return this.http.patch<AdministrationModel>(`${this.support_url}/${administration.id}/man-down`, {
      stopped_at: administration.stopped_at,
    })
  }

  /**
   * setting the current administration
   * @param administration
   */
  setCurrentAdministration(administration: AdministrationModel) {
    this.onCurrentAdministationChanged.next(administration)

    this.router.navigate(['administrations/' + administration.id])
  }

  /**
   *
   * @param {AdministrationResponse} administrationResponse
   */
  setAdministrationResponse(administrationResponse: AdministrationResponse) {
    this.onAdministrationsChanged.next(administrationResponse)
  }

  /**
   *
   * @param {AdministrationModel} administration
   */
  remoteLogin(administration: AdministrationModel) {
    const data = JSON.parse(localStorage.getItem('token'))

    window.open(
      sprintf(environment.remote_login_template, data.access_token, data.refresh_token, administration.id),
      '_blank',
    )
  }

  /**
   *
   * @param {AdministrationModel} administration
   */
  getRemoteRedirect(administration: number) {
    const data = JSON.parse(localStorage.getItem('token'))
    return sprintf(environment.remote_login_template, data.access_token, data.refresh_token, administration)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/services/administration.service.ts